import { Component, Input, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { AbstractFormControlComponent } from "@lantern/app/common/forms/abstract-form-control/abstract-form-control.component";

@Component({
  selector: "ta-static-input",
  template: `
    <ta-input
      [value]="value"
      [type]="type"
      [prefix]="prefix"
      [suffix]="suffix"
      [disabled]="true"
    ></ta-input>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StaticInputComponent),
      multi: true
    }
  ]
})
export class StaticInputComponent extends AbstractFormControlComponent<string> {
  @Input()
  type: "text" | "number" | "password" | "email" = "text";

  @Input()
  prefix?: string;

  @Input()
  suffix?: string;
}
